// src/components/ui/Spacer.js
import React from "react";

export default function Spacer({}) {
  return <span className="w-full h-0.5 bg-greyscale-3/30 rounded block"></span>;
}
